
export class CrossVision {
kind: string;
visionCode: string;
}

